import { openDB } from 'idb';
import {
  deleteNotificaionsByConversationId,
  setNotifications,
  addNotificationItem,
} from '../store/slices/notifications';
import { store } from '../store/store';

// Function to open or create the database
async function openIndexedDb() {
  const dbName = 'notificaitons_db_v3'; // Change to your desired database name
  const dbVersion = 4; // Change to your desired database version

  const result = await openDB(dbName, dbVersion, {
    upgrade(db, oldVersion, newVersion, transaction, event) {
      if (oldVersion < dbVersion) {
        // Delete the old object store table)
        oldVersion === 3 && db.deleteObjectStore('notifications_data');
        // Create or modify object stores (table)
        const objectStore = db.createObjectStore('notifications_data', {
          keyPath: 'id',
          autoIncrement: true,
        });
        // Create index for the tabel.
        objectStore.createIndex('conversation_index', ['conversation_id'], {
          unique: false,
        });
        objectStore.createIndex('person_index', ['person_id'], {
          unique: false,
        });
        objectStore.createIndex('person_and_conversaiont', ['person_id', 'conversation_id'], {
          unique: false,
        });
        objectStore.createIndex('person_and_type', ['person_id', 'type'], {
          unique: false,
        });
      }
    },
  });

  return result;
}
// Function to add data to the object store
export async function addToIndexedDb(payload: any) {
  const db = await openIndexedDb();
  const transaction = db.transaction('notifications_data', 'readwrite');
  const objectStore = transaction.objectStore('notifications_data');
  // Example: Add data to the object store
  objectStore.put(payload);
  store.dispatch(addNotificationItem(payload));
}

export const getAllNotificationByPersonId = async (person_id: number) => {
  const db = await openIndexedDb();
  const transaction = db.transaction('notifications_data', 'readwrite');
  const objectStore = transaction.objectStore('notifications_data');
  // const conversationIdQuery = await objectStore.index("person_index").getAll([person_id]);
  const conversationIdQuery = await objectStore.getAll();
  const data = conversationIdQuery.filter((el) => el.person_id === person_id);
  store.dispatch(setNotifications(data));
};

export async function deleteByPersonIdandConversationId(
  person_id: number,
  conversation_id: string
) {
  const db = await openIndexedDb();
  const transaction = db.transaction('notifications_data', 'readwrite');
  const objectStore = transaction.objectStore('notifications_data');
  objectStore
    .index('person_and_conversaiont')
    .openCursor([person_id, conversation_id])
    .then(async (cursor) => {
      while (cursor) {
        cursor.delete();
        cursor = await cursor.continue();
      }
    });
  store.dispatch(deleteNotificaionsByConversationId(conversation_id));
}

export async function deleteByPersonIdandType(person_id: number, type: string) {
  const db = await openIndexedDb();
  const transaction = db.transaction('notifications_data', 'readwrite');
  const objectStore = transaction.objectStore('notifications_data');
  objectStore
    .index('person_and_type')
    .openCursor([person_id, type])
    .then(async (cursor) => {
      while (cursor) {
        cursor.delete();
        cursor = await cursor.continue();
      }
    });
  store.dispatch(setNotifications([]));
}
